import { NgIf } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { LoaderService } from '../../../core/services/loader.service';

@Component({
  selector: 'loader',
  standalone: true,
  imports: [NgIf],
  template: `
  <div class="loader" *ngIf="isLoading()">
    <div class="loader__container">
      <div class="loader__icon"></div>
    </div>
  </div>`,
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);
  isLoading = computed(() => this.loaderService.loading());
}
